/*
 * Paginador de las listas del tablero (20 filas por página, ver utils/rows.js paginate).
 * No se muestra si hay una sola página.
 */
import React from "react";

const Paginator = ({page, pages, onChange}) => {
    if (pages <= 1) return null;
    return (
        <nav className="mc-pager" aria-label="Páginas">
            <button type="button" className="mc-icon-button" aria-label="Página anterior" disabled={page <= 1}
                    onClick={() => onChange(page - 1)}>
                <i className="bx bx-chevron-left" aria-hidden="true"/>
            </button>
            <span className="mc-num">Página {page} de {pages}</span>
            <button type="button" className="mc-icon-button" aria-label="Página siguiente" disabled={page >= pages}
                    onClick={() => onChange(page + 1)}>
                <i className="bx bx-chevron-right" aria-hidden="true"/>
            </button>
        </nav>
    );
};

export default Paginator;
